import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
  import { environment } from 'src/environments/environment';
import { 
  StepBarPayload, 
  StepBarResponse, 
  SetDefaultViewTypePayload, 
  StatusBarResponse 
} from '../modals/stepbar.models';

@Injectable({
  providedIn: 'root'
})
export class WorkbookStepbarService {
  private dynamicTableAPI: string;

  constructor(private readonly http: HttpClient) {
    this.dynamicTableAPI = environment.dynamicTableAPI;
  }

  /**
   * Get step bar data for a workbook
   * @param payload Contains tableId and columnname for filtering
   * @returns Observable of step bar response array
   */
  getStepBarData(payload: StepBarPayload): Observable<StepBarResponse[]> {
    return this.http.post<StepBarResponse[]>(`${this.dynamicTableAPI}Workbook/GetStepBar`, payload);
  }

  /**
   * Get default view type for a workbook
   * @param workbookId The ID of the workbook
   * @returns Observable of string containing the default view type
   */
  getDefaultViewType(workbookId: string): Observable<string> {
    return this.http.get(`${this.dynamicTableAPI}Workbook/${workbookId}/DefaultViewType`, { responseType: 'text' });
  }

  /**
   * Set default view type for a workbook
   * @param payload Contains workbookId and viewType
   * @returns Observable of the response
   */
  setDefaultViewType(payload: SetDefaultViewTypePayload): Observable<any> {
    return this.http.post<any>(`${this.dynamicTableAPI}Workbook/SetDefaultViewType`, payload);
  }

  /**
   * Get status bar data for a workbook
   * @param workbookId The ID of the workbook
   * @returns Observable of the status bar response
   */
  getStatusBar(workbookId: string): Observable<StatusBarResponse> {
    return this.http.get<StatusBarResponse>(`${this.dynamicTableAPI}Workbook/${workbookId}/StepbarStatus`);
  }
} 